import { Button as MuiButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DeleteButton, EditButton, SaveButton, Toolbar, TopToolbar, useGetMany, useGetManyReference, useGetOne, useList, useNotify, useRecordContext, useTranslate} from 'react-admin';
import { AddPaymentButton } from '../payments/AddPaymentButton';
import { Contract } from '../types';
import AddInvoiceButton from './AddInvoiceButton';
import ConvertPreNeedButton from './ConvertPreNeedButton';
import CreditMemoButton from './CreditMemoButton';
import DisplayContractButtons from './DisplayContractButtons';
import RefundButton from './RefundButton';
import SendContractButton from './SendContractButton';



const CopyContractLinkButton = () => {
  const record = useRecordContext<Contract>();
  const notify = useNotify();
  const { data: funeral } = useGetOne(
    'funerals',
    { id: record?.funeral_id },
    { enabled: !!record?.funeral_id }
  );
  const { data: allContracts } = useGetManyReference(
    'contracts',
    { target: 'funeral_id', id: record?.funeral_id },
    { enabled: !!record?.funeral_id }
  );

  if (!record || !funeral?.uuid) return null;

  // First contract for the funeral doesn't need contractId in the URL
  const isFirstContract = allContracts
    ? allContracts.every((c) => c.id >= record.id)
    : true;

  const handleCopy = async () => {
    const fallback = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:3010' : 'https://cleocremation.com';
    const auraAppUrl = (process.env.REACT_APP_AURA_APP_URL || fallback).replace(/\/$/, '');
    const url = isFirstContract
      ? `${auraAppUrl}/app/${funeral.uuid}/contract-start`
      : `${auraAppUrl}/app/${funeral.uuid}/contract-start?contractId=${record.id}`;
    try {
      await navigator.clipboard.writeText(url);
      notify('Contract link copied to clipboard', { type: 'success' });
    } catch {
      notify('Failed to copy link', { type: 'error' });
    }
  };

  return (
    <Tooltip title="Copy signing link">
      <MuiButton
        onClick={handleCopy}
        startIcon={<ContentCopyIcon />}
        size="medium"
        sx={{ mr: 1 }}
      >
        Copy Link
      </MuiButton>
    </Tooltip>
  );
};

const ContractTopToolBar = () => {

  const record = useRecordContext<Contract>();

  const { data: supabaseInvoices } = useGetManyReference(
    'sb_invoices',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: supabaseCreditMemos } = useGetManyReference(
    'sb_creditmemos',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: qbInvoicesData, isLoading: isInvoicesLoading } = useGetMany(
    'invoices',
    {
      ids: supabaseInvoices
        ? supabaseInvoices.map((invoice) => invoice.accounting_reference_id)
        : [],
    },
    { enabled: supabaseInvoices && supabaseInvoices.length > 0 }
  );

  const { data: qbCreditMemosData, isLoading: isCMLoading } = useGetMany(
    'creditmemos',
    {
      ids: supabaseCreditMemos
        ? supabaseCreditMemos.map((cm) => cm.accounting_reference_id)
        : [],
    },
    { enabled: supabaseInvoices && supabaseInvoices.length > 0 }
  );


  const invoices = qbInvoicesData ? qbInvoicesData : [];
  const creditmemos = qbCreditMemosData ? qbCreditMemosData : [];
  const count = invoices.length + creditmemos.length;

  const linesTotal = record?.lines?.reduce((accumulator:any, line:any) => {
    return accumulator + line.price;
  }, 0);

  return record ? (
    <TopToolbar>
      { record?.legacy_lines?.length == 0 ? (
        <>
          {record.is_preneed ? <ConvertPreNeedButton /> : null}
          {linesTotal > 0 ? <AddPaymentButton /> : null}
          <RefundButton />
          <SendContractButton />
          <CopyContractLinkButton />
          {count == 0 ? <EditButton size="medium" /> : <EditButton size="medium" disabled />}
        </>
      ) : (
        <>
          {record.is_preneed ? <ConvertPreNeedButton /> : null}
          <AddPaymentButton />
          <RefundButton />
          <SendContractButton />
          <CopyContractLinkButton />
        </>
      )}
    </TopToolbar>
  ) : null;
};

export default ContractTopToolBar;

